// Type definitions for Coaching Prepare Dashboard

export interface PrepareAssociate {
    employee_number: string;
    employee_name: string;
    metrics_at_risk_count: number;
    recommended_metric_name: string;
    recommended_metric_value: number | null;
    recommended_metric_target: number | null;
    recommended_metric_type_name: string;  // For formatting (Percentage, Numeric, Currency, Decimal, Time)
    recommended_metric_direction_id: number;  // For icon (1=Ascending ↑, 2=Descending ↓)
    metric_attained: boolean;  // For color coding (true=green, false=red)
    recommended_action_type: string;
    active_action_plan_count: number;
    next_follow_up_date: string | null;
    scorecard_metric_id: number;
    coaching_next_best_action_id: number;
    coaching_action_plan_id: number | null;
    // Status of the linked coaching action plan (null when no plan exists)
    coaching_action_plan_status_id: number | null;
    // Whether the NBA recommendation has been actioned
    is_actioned: boolean;
    // Model switch: 1 = legacy, 2 = tier.
    scorecard_calculation_rule_id?: number | null;
}

export interface PrepareAssociateMetric {
    coaching_next_best_action_metric_id: number;
    scorecard_metric_id: number;
    metric_name: string;
    metric_value: number | null;
    target: number | null;
    metric_attained: boolean;
    coaching_next_best_action_type_id: number;
    coaching_next_best_action_type_name: string;  // 'Start Coaching' | 'Recognize' | 'Follow Up' etc
    metric_type_id: number;
    metric_type_name: string;  // For formatting (Percentage, Numeric, etc)
    metric_direction_id: number;  // 1=Ascending, 2=Descending
    start_date: string | null;
    end_date: string | null;
    coaching_action_plan_id: number | null;
    session_count: number;
    latest_session_id: number | null;
    coaching_action_plan_status_id: number | null;
    is_payout_metric: boolean;
    metric_start_value_override: number | null;
    metric_start_value_override_reason: string | null;
    // Tier model fields (null for legacy scorecard_calculation_rule_id = 1)
    scorecard_calculation_rule_id?: number | null;
    attainment_rank?: number | null;
    metric_attainment_level_label?: string | null;
    targets?: any[] | null;
    min?: number | null;
    max?: number | null;
}

export interface PrepareMetricChartData {
    calculation_date: string;
    metric_value: number | null;
    target: number | null;
    metric_attained: boolean;
}

export interface PrepareApiResponse<T> {
    statusCode: number;
    message: string;
    data: T;
}

// Metric Type IDs
export enum MetricType {
    Numeric = 1,
    Percentage = 2,
    Currency = 3,
    Decimal = 4,
    Time = 5
}

// Metric Direction IDs (for icon display)
export enum MetricDirection {
    Ascending = 1,  // Higher is better - use up arrow
    Descending = 2  // Lower is better - use down arrow
}

export enum MetricRecommendation {
    Yes = 1,  // Higher is better - use up arrow
    No = 2  // Lower is better - use down arrow
}
